export default {
  appName: 'KeyzoStore',

  // Generic actions
  actions: {
    addToCart: 'Add to cart',
    buyNow: 'Buy now',
    save: 'Save',
    saveChanges: 'Save changes',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    back: 'Back',
    close: 'Close',
    search: 'Search',
    loadMore: 'Load more',
    viewAll: 'View all',
    viewDetails: 'View details',
    remove: 'Remove',
    edit: 'Edit',
    delete: 'Delete',
    apply: 'Apply',
    submit: 'Submit',
    retry: 'Try again',
    copy: 'Copy',
    copied: 'Copied',
    signIn: 'Log in',
    signUp: 'Sign up',
    signOut: 'Sign out',
    backToTop: 'Back to top',
  },

  // Mini cart slide-over (components/cart/MiniCart.vue)
  miniCart: {
    title: 'Your cart · {count}',
    limit: '{count} of {limit}',
    signedOutTitle: 'Log in to use your cart',
    signedOutBody: 'Sign in to add keys to your cart and check out.',
    emptyTitle: 'Your cart is empty',
    emptyBody: 'Keys you add show up here, ready for checkout.',
    browse: 'Browse catalog',
    checkout: 'Checkout',
    decrease: 'Decrease quantity of {name}',
    increase: 'Increase quantity of {name}',
    remove: 'Remove {name}',
  },

  // Generic states
  state: {
    loading: 'Loading…',
    saving: 'Saving…',
    error: 'Something went wrong',
    success: 'Success',
    empty: 'Nothing here yet',
    noResults: 'No results found',
  },

  // Generic labels
  label: {
    price: 'Price',
    total: 'Total',
    subtotal: 'Subtotal',
    quantity: 'Quantity',
    platform: 'Platform',
    region: 'Region',
    language: 'Language',
    genre: 'Genre',
    status: 'Status',
    date: 'Date',
    email: 'Email',
    password: 'Password',
    all: 'All',
    yes: 'Yes',
    no: 'No',
  },

  // Toasts (stores/toast.ts) — the only notification pattern
  toast: {
    addedToCart: 'Added to cart',
    viewCart: 'View cart',
    cartLimit: 'Cart is full — {limit} keys per order',
    savedToWishlist: 'Saved to wishlist',
    removedFromWishlist: 'Removed from wishlist',
    viewWishlist: 'View wishlist',
    undo: 'Undo',
    removedFromCart: 'Removed from cart',
    linkCopied: 'Link copied',
    keyCopied: 'Key copied',
  },

  price: {
    from: 'from',
  },

  rail: {
    previous: 'Previous',
    next: 'Next',
  },

  breadcrumbs: {
    label: 'Breadcrumb',
    home: 'Home',
  },

  // Order / payment status labels (keyed by backend status code)
  orderStatus: {
    CREATED: 'Created',
    PAID: 'Paid',
    PROCESSING: 'Processing',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    REFUNDED: 'Refunded',
  },
};
